import {gql} from '@apollo/client'

// Query to get all contact tags
export const GET_CONTACT_TAGS = gql`
  query GetContactTags {
    contactTags {
      id
      name
      color
      description
      contactCount
      createdAt
      updatedAt
    }
  }
`

// Mutation to create a new tag
export const CREATE_CONTACT_TAG = gql`
  mutation CreateContactTag($name: String!, $color: String, $description: String) {
    createContactTag(name: $name, color: $color, description: $description) {
      ok
      tag {
        id
        name
        color
        description
      }
    }
  }
`

// Mutation to update a tag
export const UPDATE_CONTACT_TAG = gql`
  mutation UpdateContactTag($id: ID!, $name: String, $color: String, $description: String) {
    updateContactTag(id: $id, name: $name, color: $color, description: $description) {
      ok
      tag {
        id
        name
        color
        description
      }
    }
  }
`

// Mutation to delete a tag
export const DELETE_CONTACT_TAG = gql`
  mutation DeleteContactTag($id: ID!) {
    deleteContactTag(id: $id) {
      ok
    }
  }
`

// Mutation to assign tags to contacts (bulk)
export const ASSIGN_CONTACT_TAGS = gql`
  mutation AssignContactTags($contactIds: [ID!]!, $tagIds: [ID!]!) {
    assignContactTags(contactIds: $contactIds, tagIds: $tagIds) {
      ok
      assignedCount
    }
  }
`

// Mutation to unassign tags from contacts (bulk)
export const UNASSIGN_CONTACT_TAGS = gql`
  mutation UnassignContactTags($contactIds: [ID!]!, $tagIds: [ID!]!) {
    unassignContactTags(contactIds: $contactIds, tagIds: $tagIds) {
      ok
      unassignedCount
    }
  }
`
